import axiosInstance from "../../../../Shared/Utils/axiosInstance";
import { ComissionApi } from "../../../../Shared/Constants/api";
import { getComissionCreationObject } from "../Data/ComissionWrappers";

export const createComissionApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${ComissionApi}`,
      getComissionCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
